import { Stack, useTheme } from '@mui/material';
import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import CustomerRanchBlockDropdowns from '../commonUI/dropdowns/CustomerRanchBlockDropdowns';
import ScansSearchBar from './ScanSection/components/scanSearch/ScansSearchBar';
import { ScanList } from './ScanSection/ScanList';
import {
  selectScansBlockID,
  selectScansCustomerID,
  selectScansRanchID,
  setScansBlockID,
  setScansCustomerID,
  setScansRanchID,
} from './scansSlice';
import { UploadsSection } from './UploadSection/UploadsSection';

export const ScansPage = () => {
  const theme = useTheme();
  const pageSpacing = theme.spacing(5);
  const scansCustomerId =
    useAppSelector(selectScansCustomerID) ?? 'ALL_CUSTOMERS';
  const scansRanchId = useAppSelector(selectScansRanchID) ?? 'ALL_RANCHES';
  const scansBlockId = useAppSelector(selectScansBlockID) ?? 'ALL_BLOCKS';

  const dispatch = useAppDispatch();
  const updateScansCustomerId = useCallback(
    (id: string) => {
      dispatch(setScansCustomerID(id));
    },
    [dispatch]
  );

  const updateScansRanchId = useCallback(
    (id: string) => {
      dispatch(setScansRanchID(id));
    },
    [dispatch]
  );

  const updateScansBlockId = useCallback(
    (id: string) => {
      dispatch(setScansBlockID(id));
    },
    [dispatch]
  );

  return (
    <Stack
      sx={{
        width: '100%',
        height: '100%',
        maxHeight: '100%',
        p: pageSpacing,
        gap: pageSpacing,
        overflow: 'hidden',
      }}
    >
      {/* Top navbar dropdown section */}
      <CustomerRanchBlockDropdowns
        customer={scansCustomerId === '' ? 'ALL_CUSTOMERS' : scansCustomerId}
        onCustomerChange={updateScansCustomerId}
        ranch={scansRanchId === '' ? 'ALL_RANCHES' : scansRanchId}
        onRanchChange={updateScansRanchId}
        block={scansBlockId === '' ? 'ALL_BLOCKS' : scansBlockId}
        onBlockChange={updateScansBlockId}
      />

      {/* Main content area - Uploads / Scans */}
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        sx={{
          width: '100%',
          height: '100%',
          overflow: 'hidden',
          gap: pageSpacing,
        }}
      >
        {/* Upload column */}
        <Stack
          sx={{
            height: { xs: 'unset', md: '100%' },
            maxHeight: { xs: '50%', md: '100%' },
            width: { xs: '100%', md: '28rem' },
            overflow: 'hidden',
            gap: pageSpacing,
            flexShrink: 0,
          }}
        >
          <ScansSearchBar />
          <UploadsSection />
        </Stack>

        {/* Scans column */}
        <ScanList />
      </Stack>
    </Stack>
  );
};
